export default {
  inventory: {},
  inventoryOrder: {
    docs: [],
  },
  inventoryConsumables: {},
  inventoryPricelists: {},
  inventoryReturns: {},
  inventoryServices: {},
  inventoryTransfers: {
    docs: [],
  },
};
